import { useMutation } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';

import { mediaManagerClient } from '@/lib/axios';
import { MutationConfig } from '@/lib/react-query';
import { useNotificationStore } from '@/stores/notifications';

import { TClipLogo } from '../types';

type TDeleteClipLogoParams = {
  id: string;
  silently?: boolean;
};
export async function deleteClipLogo({ id }: TDeleteClipLogoParams): Promise<TClipLogo> {
  return mediaManagerClient.delete(`/api/v1/clip_logos/${id}`);
}

type MutationFn = typeof deleteClipLogo;

type TUsePostFeaturedPeopleParams = {
  config?: MutationConfig<MutationFn>;
};

export function useDeleteClipLogo({ config = {} }: TUsePostFeaturedPeopleParams = {}) {
  const { t } = useTranslation();
  const { addErrorNotification, addSuccessNotification } = useNotificationStore();

  return useMutation({
    ...config,
    mutationFn: ({ silently = false, ...params }: TDeleteClipLogoParams) =>
      deleteClipLogo({ ...params, silently }),
    onError(error) {
      addErrorNotification(t('No se ha podido eliminar el logo del corte'));
      console.error(error);
    },
    onSuccess(_data, variables: TDeleteClipLogoParams) {
      if (!variables.silently) {
        addSuccessNotification(t('El logo del corte se ha eliminado correctamente'));
      }
    },
  });
}
